import React from "react";
import Box from "@mui/material/Box";
import { numberFormatter } from "@ecommerce/shared-utils";
import { AppConfigFields } from "../../types/appConfigEntities";
import { TOP_BANNER_HEIGHT } from "./Navbar/NavbarConstants";
import { getMinimumPurchaseAmount } from "../../utils/purchaseRules";

const DEFAULT_DISCOUNTS = window.APP_CONFIG?.[AppConfigFields.Discounts] ?? [
    { percent: "10% OFF", threshold: "$600.000" },
    { percent: "15% OFF", threshold: "$1.500.000" },
    { percent: "20% OFF", threshold: "$2.000.000" },
];

export const MinimumBuyBanner: React.FC = () => {
    const minimumPurchase = getMinimumPurchaseAmount();

    const discountsText = DEFAULT_DISCOUNTS
        .map(d => `${d.percent} +${d.threshold}`)
        .join(" · ");

    const fullText = minimumPurchase > 0
        ? `Compra Mínima ${numberFormatter.toStringWithAmount(minimumPurchase, "$", 0)} // ${discountsText}`
        : discountsText;

    return (
        <Box
            id="top-banner"
            bgcolor="#0101014D"
            color="white"
            position="fixed"
            top={0}
            left={0}
            right={0}
            zIndex={1400}
            sx={{
                height: TOP_BANNER_HEIGHT,
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
            }}
        >
            {/*
             * 4 copias idénticas con gap fijo entre ellas.
             * La animación avanza exactamente una copia (-25% del total),
             * por lo que el loop es invisible en cualquier ancho de pantalla.
             */}
            <Box
                sx={{
                    display: "inline-flex",
                    animation: "marquee-banner 15s linear infinite",
                    "@keyframes marquee-banner": {
                        from: { transform: "translateX(0)" },
                        to: { transform: "translateX(-25%)" },
                    },
                }}
            >
                {[0, 1, 2, 3].map((i) => (
                    <Box
                        key={i}
                        component="span"
                        sx={{
                            fontFamily: '"Rubik", sans-serif',
                            fontSize: "13px",
                            color: "white",
                            lineHeight: 1.3,
                            whiteSpace: "nowrap",
                            pr: "5rem",
                        }}
                    >
                        {fullText}
                    </Box>
                ))}
            </Box>
        </Box>
    );
};














